export default __webpack_public_path__ + "static/1-26364ff946054d2cff7f9bce5a2d8cd4.jpeg";